import './ImportantButton.css';

const ImportantButton = ({buttonText, onClick, children, tooltip}) => {
    return(
        <div className={tooltip ? "text-center important-button-fullwidth-wrapper" : "text-center"}>
            <button className="important-button" onClick={onClick}>
                {children ?? buttonText}
            </button>
            {tooltip && <div className="important-button-tooltip">{tooltip}</div>}
        </div>
    )
}

export { ImportantButton }